export * as Api from './api';
export var InvestorReportingType;
(function (InvestorReportingType) {
    InvestorReportingType["Periodic"] = "Periodic";
    InvestorReportingType["CustomUpdate"] = "Custom Update";
    InvestorReportingType["DeploymentUpdate"] = "Deployment Update";
    InvestorReportingType["ExitStatement"] = "Exit Statement";
})(InvestorReportingType || (InvestorReportingType = {}));
//# sourceMappingURL=index.js.map